// @flow

import DataFetcher from "./DataFetcher";

export default DataFetcher;
